import React from "react";

export default function NotFound() {
  return (
    <div className="container">
      <div className="card">
        <div className="header">
          <h1>404 - Page Not Found</h1>
        </div>
        <div className="content">
          <p>The page you are looking for does not exist.</p>
          <a href="/" className="btn-return">Return to Home</a>
        </div>
      </div>
    </div>
  );
}
